import { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import CoachPage from "../../component/coach-page";

const Coach = () => {
  const navigate = useNavigate();
  const params = useParams();
  const challengeId = useMemo(() => {
    return Number(params.challengeId || 0);
  }, [params]);
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");
  const [refreshing, setRefreshing] = useState(false);

  // 刷新页面
  const refresh = () => {
    setRefreshing(true);
    setTimeout(() => {
      setRefreshing(false);
    }, 0);
  };

  useEffect(() => {
    refresh();
  }, [challengeId]);

  // todo: 获取会员资格，判断是否可以查看答案 hideAnswer

  return (
    <>
      {!refreshing && (
        <CoachPage
          mode="题库"
          visible
          hideAnswer
          challengeId={challengeId}
          onClose={() => {
            if (redirect) return navigate(redirect);
            navigate(-1);
          }}
        />
      )}
    </>
  );
};

export default Coach;
